import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '120px'
  },
  public: {
    marginRight: theme.spacing(3),
    color: 'white'
  },
  menu: {
    marginRight: theme.spacing(3)
  },
  selected: {
    textTransform: 'none'
  },
  options: {
    backgroundColor: '#333333'
  },
  option: {
    textTransform: 'uppercase',
    color: '#12EBFE',
    fontSize: '12px',
    fontWeight: 600,
    padding: theme.spacing(1, 3)
  },
  popper: {
    zIndex: 1,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      right: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent #333333 transparent`
      }
    }
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid'
    }
  }
}));

export default useStyles;
